/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MallShow_mall$ref: FragmentReference;
declare export opaque type MallShow_mall$fragmentType: MallShow_mall$ref;
export type MallShow_mall = {|
  +name: string,
  +phoneNumber: string,
  +email: string,
  +pdfMapUrl: ?string,
  +address: string,
  +shareableHomeUrl: string,
  +shareableFlashSaleOffersUrl: string,
  +smallMapUrl: ?string,
  +largeMapUrl: ?string,
  +homeUrl: string,
  +flashSaleOffersUrl: string,
  +mondayOpening: number,
  +mondayClosing: number,
  +tuesdayOpening: number,
  +tuesdayClosing: number,
  +wednesdayOpening: number,
  +wednesdayClosing: number,
  +thursdayOpening: number,
  +thursdayClosing: number,
  +fridayOpening: number,
  +fridayClosing: number,
  +saturdayOpening: number,
  +saturdayClosing: number,
  +sundayOpening: number,
  +sundayClosing: number,
  +$refType: MallShow_mall$ref,
|};
export type MallShow_mall$data = MallShow_mall;
export type MallShow_mall$key = {
  +$data?: MallShow_mall$data,
  +$fragmentRefs: MallShow_mall$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MallShow_mall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdfMapUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareableHomeUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareableFlashSaleOffersUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallMapUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largeMapUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "homeUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flashSaleOffersUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mondayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mondayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fridayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fridayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sundayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sundayClosing",
      "storageKey": null
    }
  ],
  "type": "Mall"
};
// prettier-ignore
(node/*: any*/).hash = '1a410abba37757358aa15c0c7ee41ef6';

module.exports = node;
